import AppLayout from '../Layout/AppLayout';
import ContenuSetting from '../Components/ContenuSetting';

const Setting = () => {
    return (
        <AppLayout>
            <ContenuSetting />
        </AppLayout>
    );
};

export default Setting;
